<div class="space-y-6">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'CASH.TITLE' | translate }}
      </h1>
      <p class="text-gray-600 dark:text-gray-400 mt-1">{{ 'CASH.SUBTITLE' | translate }}</p>
    </div>
    <p-button icon="pi pi-plus" [label]="'CASH.ADD_TX' | translate" (onClick)="openTx()" />
  </div>

  <!--
    Kassa valyuta bo'yicha BO'LINADI (I11) — dollar bilan so'mni bitta songa
    qo'shib bo'lmaydi. Har daftar alohida ko'rsatiladi, bosilsa o'shanga o'tadi.
  -->
  @if ((balance()?.byCurrency?.length ?? 0) > 1) {
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
    >
      <div class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">
        {{ 'CASH.BY_CURRENCY' | translate }}
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        @for (row of balance()!.byCurrency; track row.currency) {
          <button
            type="button"
            (click)="onCurrencyChange(row.currency)"
            class="text-left rounded-lg border p-3 transition-colors"
            [class.border-emerald-300]="selectedCurrency() === row.currency"
            [class.dark:border-emerald-800]="selectedCurrency() === row.currency"
            [class.bg-emerald-50]="selectedCurrency() === row.currency"
            [class.dark:bg-emerald-950]="selectedCurrency() === row.currency"
            [class.border-gray-200]="selectedCurrency() !== row.currency"
            [class.dark:border-gray-700]="selectedCurrency() !== row.currency"
          >
            <div class="text-xs font-semibold text-gray-500 dark:text-gray-400">
              {{ row.currency }}
            </div>
            <div class="mt-1 text-lg font-bold text-gray-900 dark:text-gray-100">
              {{ row.cashBalance | moneyFixed: row.currency }}
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              {{ 'CASH.CARD.CARD' | translate }}: {{ row.cardNet | moneyFixed: row.currency }}
            </div>
          </button>
        }
      </div>
    </div>
  }

  <!-- Balance cards -->
  @if (balance(); as b) {
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      <div
        class="rounded-xl border border-indigo-200 dark:border-indigo-900/40 bg-indigo-50 dark:bg-indigo-950/20 p-4"
      >
        <div class="text-sm text-indigo-700 dark:text-indigo-300">
          {{ 'CASH.CARD.TOTAL_BALANCE' | translate }}
        </div>
        <div class="text-2xl font-bold text-indigo-700 dark:text-indigo-300 mt-1">
          {{ totalBalance(b) | moneyFixed: b.currency }}
        </div>
      </div>
      <div
        class="rounded-xl border border-green-200 dark:border-green-900/40 bg-green-50 dark:bg-green-950/20 p-4"
      >
        <div class="text-sm text-green-700 dark:text-green-300">
          {{ 'CASH.CARD.DRAWER' | translate }}
        </div>
        <div class="text-2xl font-bold text-green-700 dark:text-green-300 mt-1">
          {{ b.cashBalance | moneyFixed: b.currency }}
        </div>
      </div>
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
      >
        <div class="text-sm text-gray-500">{{ 'CASH.CARD.CARD' | translate }}</div>
        <div class="text-xl font-bold text-gray-900 dark:text-gray-100 mt-1">
          {{ b.cardNet | moneyFixed: b.currency }}
        </div>
      </div>
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
      >
        <div class="text-sm text-gray-500">{{ 'CASH.CARD.BANK' | translate }}</div>
        <div class="text-xl font-bold text-gray-900 dark:text-gray-100 mt-1">
          {{ b.bankNet | moneyFixed: b.currency }}
        </div>
      </div>
      <div
        class="rounded-xl border border-amber-200 dark:border-amber-900/40 bg-amber-50 dark:bg-amber-950/20 p-4"
      >
        <div class="text-sm text-amber-700 dark:text-amber-300">
          {{ 'CASH.CARD.RECEIVABLES' | translate }}
        </div>
        <div class="text-xl font-bold text-amber-700 dark:text-amber-300 mt-1">
          {{ b.receivables | moneyFixed: b.currency }}
        </div>
      </div>
    </div>
  } @else if (balanceLoading()) {
    <!--
      Yuklanayotganda joy BAND turadi: aks holda kartalar javob kelganda birdan
      paydo bo'lib, ostidagi filtr va jadvalni pastga surib yuborardi.
    -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      @for (i of balanceSkeletons; track i) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
        >
          <div class="h-4 w-24 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
          <div class="mt-2 h-7 w-32 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
        </div>
      }
    </div>
  }

  <!-- Filters -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="flex flex-col sm:flex-row gap-3 sm:items-end">
      <div class="flex flex-col gap-1">
        <label for="cash-range" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
          'CASH.PERIOD' | translate
        }}</label>
        <p-datepicker
          inputId="cash-range"
          [(ngModel)]="range"
          selectionMode="range"
          [readonlyInput]="true"
          dateFormat="dd.mm.yy"
          appendTo="body"
        />
      </div>
      <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
      @if (storePick.visible()) {
        <div class="flex flex-col gap-1">
          <label for="cash-store" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'CASH.STORE' | translate
          }}</label>
          <p-select
            inputId="cash-store"
            [options]="stores()"
            optionLabel="name"
            optionValue="id"
            [(ngModel)]="filterStoreId"
            [showClear]="true"
            [placeholder]="'CASH.ALL_STORES' | translate"
            appendTo="body"
            class="w-full sm:w-60"
          />
        </div>
      }
      <!--
        Yuqoridagi valyuta kartalari ham tanlagich, lekin ular faqat harakati BOR
        valyutalarni ko'rsatadi. Bo'sh daftarni (hali pul tushmagan) ko'rish uchun
        shu ro'yxat kerak.
      -->
      @if (currencySvc.hasMultipleCurrencies()) {
        <div class="flex flex-col gap-1">
          <label for="cash-currency" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'CASH.CURRENCY' | translate
          }}</label>
          <p-select
            inputId="cash-currency"
            [options]="currencySvc.currencyOptions()"
            optionLabel="label"
            optionValue="value"
            [ngModel]="selectedCurrency()"
            (ngModelChange)="onCurrencyChange($event)"
            appendTo="body"
            class="w-full sm:w-48"
          />
        </div>
      }
      <p-button
        icon="pi pi-search"
        [label]="'CASH.APPLY' | translate"
        severity="secondary"
        (onClick)="onFilterChange()"
      />
    </div>
  </div>

  <!-- Period totals -->
  <div class="grid grid-cols-2 gap-4">
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
    >
      <div class="text-sm text-gray-500">{{ 'CASH.PERIOD_IN' | translate }}</div>
      <!-- Yuklanayotganda 0 ko'rsatmaymiz: u haqiqiy qiymatdek o'qiladi. -->
      @if (loading()) {
        <div class="mt-2 h-6 w-28 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
      } @else {
        <div class="text-xl font-bold text-green-600 dark:text-green-400 mt-1">
          {{ totalIn() | moneyFixed: selectedCurrency() }}
        </div>
      }
    </div>
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
    >
      <div class="text-sm text-gray-500">{{ 'CASH.PERIOD_OUT' | translate }}</div>
      @if (loading()) {
        <div class="mt-2 h-6 w-28 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
      } @else {
        <div class="text-xl font-bold text-red-600 dark:text-red-400 mt-1">
          {{ totalOut() | moneyFixed: selectedCurrency() }}
        </div>
      }
    </div>
  </div>

  <!-- Flow table -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
  >
    <div class="overflow-x-auto">
      <p-table
        [value]="entries()"
        [loading]="loading()"
        [paginator]="true"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
        styleClass="p-datatable-gridlines"
        [tableStyle]="{ 'min-width': '44rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'CASH.TABLE.DATE' | translate }}</th>
            <th>{{ 'CASH.TABLE.SOURCE' | translate }}</th>
            <th>{{ 'CASH.TABLE.METHOD' | translate }}</th>
            <th>{{ 'CASH.TABLE.DESC' | translate }}</th>
            <th class="text-right">{{ 'CASH.TABLE.AMOUNT' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-e>
          <tr>
            <td class="text-sm text-gray-600 dark:text-gray-400">
              {{ e.date | date: 'dd.MM.yyyy HH:mm' }}
            </td>
            <td>
              <p-tag
                [value]="'CASH.SOURCE.' + e.source | translate"
                [severity]="sourceSeverity(e.direction)"
              />
            </td>
            <td class="text-sm">{{ 'FINANCE.METHOD.' + e.paymentMethod | translate }}</td>
            <td class="text-sm text-gray-600 dark:text-gray-400">{{ e.description || '—' }}</td>
            <td
              class="text-right font-semibold"
              [class.text-green-600]="e.direction === 'In'"
              [class.text-red-600]="e.direction === 'Out'"
            >
              {{ e.direction === 'In' ? '+' : '−' }}{{ e.amount | moneyFixed: e.currency }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center py-12 text-gray-500 dark:text-gray-400">
              <div class="flex flex-col items-center gap-2">
                <i class="pi pi-wallet text-4xl text-gray-300"></i>
                <span>{{ 'CASH.EMPTY' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Manual transaction dialog -->
<p-dialog
  [header]="'CASH.TX_DIALOG.TITLE' | translate"
  [(visible)]="txVisible"
  [modal]="true"
  [style]="{ width: 'min(30rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="flex flex-col gap-4 pt-2">
    <!-- Do'kon bitta bo'lsa `openTx()` da o'zi qo'yiladi. -->
    @if (storePick.visible()) {
      <div class="flex flex-col gap-1">
        <label for="tx-store" class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >{{ 'CASH.TX_DIALOG.STORE' | translate }} <span class="text-red-500">*</span></label
        >
        <p-select
          inputId="tx-store"
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="txForm.storeId"
          appendTo="body"
          class="w-full"
        />
      </div>
    }
    <div class="flex flex-col gap-1">
      <label for="tx-type" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
        'CASH.TX_DIALOG.TYPE' | translate
      }}</label>
      <p-select
        inputId="tx-type"
        [options]="txTypes"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="txForm.type"
        appendTo="body"
        class="w-full"
      >
        <ng-template let-opt pTemplate="item">{{ opt.label | translate }}</ng-template>
        <ng-template let-opt pTemplate="selectedItem">{{ opt.label | translate }}</ng-template>
      </p-select>
    </div>
    <div class="flex flex-col gap-1">
      <label for="tx-amount" class="text-sm font-medium text-gray-700 dark:text-gray-300"
        >{{ 'CASH.TX_DIALOG.AMOUNT' | translate }} <span class="text-red-500">*</span></label
      >
      <p-inputnumber
        inputId="tx-amount"
        [min]="1"
        [(ngModel)]="txForm.amount"
        [useGrouping]="true"
        mode="decimal"
        class="w-full"
      />
    </div>
    <!--
      QAYSI daftarga tushishi. Busiz dollar kirimi jimgina so'm kassasiga
      yozilib ketardi va qoldiq hech qachon to'g'ri chiqmasdi.
    -->
    @if (currencySvc.hasMultipleCurrencies()) {
      <div class="flex flex-col gap-1">
        <label for="tx-currency" class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >{{ 'CASH.TX_DIALOG.CURRENCY' | translate }} <span class="text-red-500">*</span></label
        >
        <p-select
          inputId="tx-currency"
          [options]="currencySvc.currencyOptions()"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="txForm.currency"
          appendTo="body"
          class="w-full"
        />
      </div>
    }
    <div class="flex flex-col gap-1">
      <label for="tx-method" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
        'CASH.TX_DIALOG.METHOD' | translate
      }}</label>
      <p-select
        inputId="tx-method"
        [options]="paymentMethods"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="txForm.paymentMethod"
        appendTo="body"
        class="w-full"
      >
        <ng-template let-opt pTemplate="item">{{ opt.label | translate }}</ng-template>
        <ng-template let-opt pTemplate="selectedItem">{{ opt.label | translate }}</ng-template>
      </p-select>
    </div>
    <div class="flex flex-col gap-1">
      <label for="tx-desc" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
        'CASH.TX_DIALOG.DESC' | translate
      }}</label>
      <input id="tx-desc" type="text" pInputText [(ngModel)]="txForm.description" class="w-full" />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      [label]="'COMMON.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="txVisible = false"
      [disabled]="txSaving"
    />
    <p-button
      [label]="'COMMON.SAVE' | translate"
      icon="pi pi-check"
      (onClick)="saveTx()"
      [loading]="txSaving"
    />
  </ng-template>
</p-dialog>
